import React, { forwardRef, useImperativeHandle } from 'react';
import { useLocation } from 'react-router';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

const DocketPDF = forwardRef(({ state }, ref) => {
  const pickup = state?.pickupDetails;
  const customer = pickup?.Consigner[0];
  const consignee = pickup?.Consignee[0];
  const pkg = pickup?.PackageDetails[0];

console.log(pickup,"pickup")
  const generatePDF = () => {
    const docDefinition = {
       pageSize: 'A4',
      pageMargins: [20, 20, 20, 30],
      content: [
        {
          columns: [
            {
              width: 'auto',
              stack: [
                // { image: 'logo', width: 80, margin: [0, 0, 0, 4] },
                { text: '1234567896', fontSize: 9 },
                { text: 'xyz@gmail.com', fontSize: 9 }
              ],
              border: [true, true, true, true]
            },
            {
              width: '*',
              table: {
                widths: ['*'],
                body: [[{ text: 'CONSIGNMENT NOTE NUMBER\n20261037', alignment: 'center', style: 'noteBox', border: [true, true, true, true] }]]
              },
              layout: 'noBorders'
            },
            {
              width: 'auto',
              table: {
                widths: ['*', '*'],
                body: [
                  ['SERVICE', 'DOCKET NUMBER'],
                  ['SURFACE', pickup?.DocketId || ''],
                  ['ORIGIN', 'DESTINATION'],
                  [pickup?.Origin || '', pickup?.Destination || '']
                ]
              },
              layout: {
                hLineWidth: () => 1,
                vLineWidth: () => 1,
                hLineColor: () => '#000',
                vLineColor: () => '#000'
              }
            }
          ]
        },
        '\n',
        {
          columns: [
            {
              width: '65%',
              stack: [
              { text: 'SHIPPER A/C:', bold: true, margin: [0, 0, 2, 2] },
                {
                table: {
                 body: [[
                    {
                      stack: [
                        { text: 'Consignor', bold: true },
                        { text: `${customer?.CompanyName || ''}, ${customer?.BillingAddress || ''}` },
                        { text: `Mobile: ${customer?.Mobile || ''}` }
                      ],
                      fontSize: 9,
                      border: [true, true, true, true],
                      margin: [5, 5, 5, 5]
                    }
                  ]]
                },
              layout: 'noBorders'
               }
            ]
            },
            {
              width: '35%',
              table: {
                body: [[
                  {
                    text: `Date: ${moment(pickup?.PickupDateAndTime).format("DD-MMM-YYYY")}\n\nConsignee\n${consignee?.CustomerName || ''}\n${consignee?.BillingAddress || ''}\nMobile: ${consignee?.Mobile || ''}`,
                    fontSize: 9,
                    border: [true, true, true, true],
                    margin: [5, 5, 5, 5]
                  }
                ]]
              },
              layout: 'noBorders'
            }
          ]
        },
        '\n',
        {
          table: {
            headerRows: 1,
            widths: ['auto', '*', '*', '*', '*', '*', '*', '*'],
            body: [
              [
                'No. of PCS',
                'Packing',
                'CONTENTS (SAID TO CONTAIN)',
                'DIM (cm) L*W*H',
                'INVOICE NO',
                'INVOICE VALUE',
                'ACTUAL WEIGHT',
                'Special Remarks'
              ],
              [
                '1',
                pkg?.BoxType || '',
                pickup?.Content || '',
                `${pkg?.length || 0}*${pkg?.breadth || 0}*${pkg?.height || 0}`,
                '---',
                '---',
                pkg?.Volumetrix || '',
                pickup?.Remark || ''
              ]
            ]
          },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => '#000',
            vLineColor: () => '#000'
          }
        },
        '\n',
        {
          columns: [
            {
              width: '33%',
              table: {
                body: [[
                  {
                    stack: [
                      { text: 'TERM & CONDITION', style: 'subheader', margin: [0, 0, 0, 4] },
                      { text: "SENDER'S NAME: -----------", fontSize: 9 },
                      { text: "SIGNATURE: -----------", fontSize: 9 }
                    ],
                    border: [true, true, true, true],
                    margin: [5, 5]
                  }
                ]]
              },
              layout: 'noBorders'
            },
            {
              width: '34%',
              table: {
                body: [[
                  {
                    stack: [
                      { text: 'CONDITION & LIABILITY', style: 'subheader', margin: [0, 0, 0, 4] },
                      { text: '', fontSize: 9 }
                    ],
                    border: [true, true, true, true],
                    margin: [5, 5]
                  }
                ]]
              },
              layout: 'noBorders'
            },
            {
              width: '33%',
              table: {
                body: [[
                  {
                    stack: [
                      { text: 'RECEIVED BY KHIMJI POONJA COLD CHAIN LOGISTICS', bold: true, fontSize: 9 },
                      { text: 'SIGNATURE: ____________________', fontSize: 9 },
                      { text: 'DATE: ________  TIME: ________', fontSize: 9 }
                    ],
                    border: [true, true, true, true],
                    margin: [5, 5]
                  }
                ]]
              },
              layout: 'noBorders'
            }
          ]
        },
        '\n\n',
        {
          columns: [
            { width: '*', text: '' },
            {
              width: '60%',
              text: 'ALL DISPUTES ARE SUBJECT TO BHIWANDI JURISDICTION',
              alignment: 'center',
              fontSize: 9,
              bold: true
            },
            {
              width: '*',
              text: 'CUSTOMER COPY',
              alignment: 'right',
              fontSize: 9,
              bold: true
            }
          ]
        }
      ],
      images: {
        logo: 'data:image/png;base64,' // Replace with actual base64
      },
      styles: {
        subheader: { fontSize: 10, bold: true, decoration: 'underline' },
        noteBox: {
          fontSize: 10,
          bold: true,
          margin: [0, 0, 0, 4],
          decoration: 'underline'
        }
      }
    };

    pdfMake.createPdf(docDefinition).open(); // Or use download() to download
  };

   // Expose the generatePDF method to parent via ref
  useImperativeHandle(ref, () => ({
    generatePDF
  }));
  
  return (
    <div>
      {/* Your docket content (no button here) */}
      <p>This is the Docket Preview</p>
    </div>
  );
});

export default DocketPDF;
